import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { isWebViewMode } from '../utils/webviewUtils';
import './WhatsAppFab.css';

// Sağ-altta sabit WhatsApp destek butonu. Numara ve hazır mesaj mobil
// projeyle aynı (905401551333 + support_whatsapp_message).
const PHONE = '905401551333';

const WhatsAppFab = () => {
  const { t } = useTranslation();

  // WebView (mobil uygulama) içinde gösterme; uygulamanın kendi WhatsApp'ı var.
  if (isWebViewMode()) return null;

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(t('whatsapp.message'))}`;
  const label = t('whatsapp.label');

  return (
    <a
      className="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
    >
      <FontAwesomeIcon icon={faWhatsapp} />
      <span className="whatsapp-fab-tooltip">{label}</span>
    </a>
  );
};

export default WhatsAppFab;
